import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation, model, signal } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';

type Severity = 'info' | 'success' | 'warn' | 'danger' | 'secondary' | 'contrast' | undefined;

@Component({
  selector: 'app-ag-tag',
  templateUrl: './ag-tag.component.html',
  styleUrls: ['./ag-tag.component.css'],
  encapsulation: ViewEncapsulation.None,
  imports: [TagModule, CommonModule, TooltipModule],
})
export class AgTagComponent<T> implements ICellRendererAngularComp {
  public readonly label = model<string | undefined>(undefined);
  public readonly customClass = model<string | undefined>(undefined);
  public readonly severity = signal<Severity>(undefined);
  public readonly icon = signal<string | undefined>(undefined);
  public readonly url = signal<string | undefined>(undefined);
  public readonly tooltip = signal<string | undefined>(undefined);

  public agInit(params: ICellRendererParams<T, unknown, unknown>): void {
    const value = params.node.data;

    if (params.colDef?.cellRendererParams?.label) {
      this.label.set(params.colDef?.cellRendererParams.label(value, params.node));
    }
    if (params.colDef?.cellRendererParams?.severity) {
      const severity = params.colDef?.cellRendererParams.severity(value, params.node);
      const primeNgSeverities = ['primary', 'success', 'info', 'warn', 'danger'];

      if (!primeNgSeverities.includes(severity)) {
        this.customClass.set(severity);
      } else {
        this.severity.set(params.colDef?.cellRendererParams.severity(value, params.node));
      }
    }
    if (params.colDef?.cellRendererParams?.icon) {
      this.icon.set(params.colDef?.cellRendererParams?.icon(value, params.node));
    }
    if (params.colDef?.cellRendererParams?.url) {
      this.url.set(params.colDef?.cellRendererParams?.url(value, params.node));
    }
    if (params.colDef?.cellRendererParams?.tooltip) {
      this.tooltip.set(params.colDef?.cellRendererParams?.tooltip(value, params.node));
    }
  }

  public refresh(params: ICellRendererParams<T, unknown, unknown>): boolean {
    this.agInit(params);
    return true;
  }

  public goTo(url: string | undefined) {
    if (url) {
      window.open(url, '_blank');
    }
  }
}
